'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const mediator = require('./../../core/mediator');
const container = require('./../../core/container');
const FormBuilder = require('./../form');
const PopinManager = require('./../popin');
const Translator = require('./../../core/translator');
const Notifier = require('./../notifier');
const RequestHandler = require('./../../core/requestHandler');
const Loader = require('./../loader');
const Help = require('./../help');
const Zone = require('./../../services/structure/zone');

const HEADER_API_KEY = 'X-API-KEY';
const HEADER_API_SIGNATURE = 'X-API-SIGNATURE';
const STORAGE_KEY = 'bb-session-auth';

let nbRequest = 0;
let isNotified = false;

const authentication = {

  popin: null,
  form: null,

  init: function() {
    if (!this.isAuthentified()) {
      let detail = {prevent: false};
      mediator.publish('before:show-form:auth', {detail});
      document.dispatchEvent(new CustomEvent('before:show-form:auth', {detail}));

      if (detail.prevent !== true) {
        this.showForm();
      }
    } else {
      mediator.publish('connected');
    }
  },

  beforeRequestSend: function(request) {
    let state = this.getState();

    nbRequest = nbRequest + 1;

    if (null !== state) {
      request.addHeader(HEADER_API_KEY, state[HEADER_API_KEY]);
      request.addHeader(HEADER_API_SIGNATURE, state[HEADER_API_SIGNATURE]);
    }
  },

  onRequestFail: function(data) {
    let {response} = data;

    if (response.status === 401) {
      let detail = {prevent: false};

      document.dispatchEvent(new CustomEvent('on:auth:fail', {detail}));

      if (!isNotified && nbRequest > 2) {
        isNotified = true;
        Notifier.warning(Translator.translate('session_expired'));
      }

      this.clearState();

      if (detail.prevent !== true) {
        this.showForm();
      }

      if (container.get('$smallPanel')) {
        Zone.closeLayer(container.get('$smallPanel'));
      }
    } else if (response.status === 403) {
      Notifier.error(response.getErrorText());
    }
  },

  persist: function(response) {
    let state = {};

    state[HEADER_API_KEY] = response.getHeader(HEADER_API_KEY) || response.getHeader(HEADER_API_KEY.toLowerCase());
    state[HEADER_API_SIGNATURE] = response.getHeader(HEADER_API_SIGNATURE) || response.getHeader(HEADER_API_SIGNATURE.toLowerCase());

    if (this.authenticationStateIsValid(state)) {
      this.persistToSession(state);
    } else {
      Notifier.error(response.getErrorText());
    }
  },

  authenticate: function(username, password) {
    let dfd = jQuery.Deferred();
    let self = this;

    RequestHandler.setBaseUrl('/rest/2');
    RequestHandler.create('security/authentication', {
      username: username,
      password: password,
    }).done(function(data, response) {
      self.persist(response);
      dfd.resolve();

      return data;
    }).fail(function(response) {
      dfd.reject(response);
    });

    return dfd.promise();
  },

  transformXhr: function(xhr) {
    let state = this.getState();

    xhr.setRequestHeader('X-API-KEY', state['X-API-KEY']);
    xhr.setRequestHeader('X-API-SIGNATURE', state['X-API-SIGNATURE']);

    return xhr;
  },

  isAuthentified: function() {
    return null !== this.getState();
  },

  authenticationStateIsValid: function(state) {
    return state[HEADER_API_KEY] !== null && state[HEADER_API_SIGNATURE] !== null;
  },

  persistToSession: function(state) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  },

  getState: function() {
    let state = localStorage.getItem(STORAGE_KEY);

    return (state !== null) ? JSON.parse(state) : null;
  },

  clearState: function() {
    localStorage.removeItem(STORAGE_KEY);
  },

  getStorageKey: function() {
    return STORAGE_KEY;
  },

  logout: function(reload, popin = true) {
    mediator.publish('on:logout', {reload, popin});
  },

  onValidate: function(data, form) {
    if (_.isEmpty(data.login)) {
      form.addError('login', Translator.translate('missing_login'));
    }

    if (_.isEmpty(data.password)) {
      form.addError('password', Translator.translate('missing_password'));
    }
  },

  onSubmit: function(data, form) {
    let self = this;
    Loader.start(this.popin.rootElement.parents('.cloud-dialog:first'), 'bottom-lg');

    this.authenticate(data.login, data.password).done(function() {
      form.popin.hide();

      location.reload();
    }).fail(function(response) {
      Loader.stop(self.popin.rootElement.parents('.cloud-dialog:first'));

      if (response.status === 401) {
        form.addFormError(Translator.translate('bad_credentials'));
      } else {
        Notifier.error(Translator.translate('an_error_occured'));
      }
    });
  },

  showForm: function(errorMessage) {
    jQuery('#cloud-starter-overlay').remove();

    if (this.popin) {
      this.popin.display();

      if (this.form && errorMessage) {
        this.form.addFormError(errorMessage);
      }

      return;
    }

    let self = this;
    let $content;
    let searchUrl = window.location.search;
    let formConfig = {
      'elements': {
        'login': {
          'type': 'text',
          'placeholder': Translator.translate('login'),
          'wrap_class': 'cloud-group mb-2',
        },
        'password': {
          'type': 'password',
          'placeholder': Translator.translate('password'),
        },
      },
    };
    let popinConfig = {
      'title': Translator.translate('connection'),
      'close': function() {
        location.reload();
      },
    };

    if (container.get('isMobile')) {
      popinConfig.classes['ui-dialog'] = 'cloud-dialog auth-mobile';
      formConfig.form = {'submit_label': Translator.translate('sign_in')};
    } else {
      popinConfig.buttons = [
        {
          class: 'popin popin-cancel',
          text: Translator.translate('cancel-auth'),
          click: function() {
            self.popin.hide();
          },
        },
        {
          class: 'popin popin-ok',
          text: Translator.translate('submit'),
          click: function() {
            self.form.submit();
          },
        },
      ];

      formConfig.form = {'submit_class': 'd-none'};
    }

    if (searchUrl) {
      searchUrl = searchUrl.substring(1);

      if (searchUrl) {
        _.forEach(searchUrl.split('&'), (value) => {
          let values = value.split('=');

          if (values[0] === 'email' && values[1]) {
            formConfig.elements.login.value = window.decodeURIComponent(values[1]);

            return true;
          }
        });
      }
    }

    this.form = FormBuilder.getForm(formConfig);

    if (errorMessage) {
      this.form.addFormError(errorMessage);
    }

    this.popin = PopinManager.createPopin(popinConfig);

    this.form.on('validate', this.onValidate.bind(this));
    this.form.on('submit', this.onSubmit.bind(this));

    this.form.popin = this.popin;

    $content = jQuery(this.form.render());

    if (container.get('isMobile')) {
      $content.prepend('<p class="brand"><i class="icon icon-backbee"></i></p>');
    }

    this.popin.setContent($content);

    this.popin.rootElement.parent().find('.ui-dialog-titlebar:first')
      .find('.ui-dialog-title:first')
      .append(Help.createLink('authentication'));

    this.popin.display();
  },
};

module.exports = authentication;

window.auth = window.auth || {};

window.auth.object = authentication;
window.auth.HEADER_API_KEY = HEADER_API_KEY;
window.auth.HEADER_API_SIGNATURE = HEADER_API_SIGNATURE;
